export default "__VITE_ASSET__BxVqwh4s__"